import React from 'react';
import { H2 } from '../heading';
import * as styles from './styles.module.less';

interface IProps {
  className?: string;
  contentClass?: string;
  paddingBottom?: string;
  paddingTop?: string;
  title?: React.ReactNode | string;
  desc?: React.ReactNode | string | JSX.Element;
  blokBg?: string;
  isNewLayout?: boolean;
  isNewEnLayout?: boolean;
  children?: React.ReactNode;
  maxWidth?: string;
  titleDescClass?: string;
  id?: string;
}

const CommonBlok = ({
  className,
  title,
  desc,
  blokBg = 'transparent',
  paddingBottom,
  paddingTop,
  isNewLayout,
  isNewEnLayout,
  titleDescClass,
  contentClass,
  maxWidth,
  children,
  id,
}: IProps) => {
  let finalLayout = styles.common_layout;
  if (isNewLayout) {
    finalLayout = styles.new_common_layout;
  } else if (isNewEnLayout) {
    finalLayout = styles.new_common_en_layout;
  }
  return (
    <div
      className={`${className ? className : ''} ${finalLayout}`}
      style={{ background: blokBg, paddingBottom, paddingTop }}
      id={id}
    >
      <div className={`${styles.common_container} ${contentClass}`} style={maxWidth ? { maxWidth: maxWidth } : {}}>
        {(title || desc) && (
          <div className={`${styles.common_title_desc_container} ${titleDescClass}`}>
            {title && (typeof title === 'string' ? <H2>{title}</H2> : title)}
            {desc && (typeof desc === 'string' ? <p className={styles.common_desc}>{desc}</p> : desc)}
          </div>
        )}
        <div className={styles.common_children}>{children}</div>
      </div>
    </div>
  );
};

export default CommonBlok;
